/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { DatetimeInput as DatetimeInputKit, createDefaultDatetimeInputControl } from '@veeam/components';
import React from 'react';

import { formatDate } from '../../helpers/date-helpers';

import type { CustomDatetimeInputProps } from './interfaces';

export const DatetimeInput: React.FC<CustomDatetimeInputProps> = (props) => {
    const { format, ...restProps } = props;

    return (
        <DatetimeInputKit
            controlRenderer={format ? createDefaultDatetimeInputControl({
                valueFormatter: ({ value }) => {
                    if (!value) return null;

                    return formatDate(value, format.toUpperCase());
                },
            }) : null}
            {...restProps}
        />
    );
};
